export default __webpack_public_path__ + "static/media/flag-fr-CH.182579b3.png";